import { rem } from '@mantine/core';
import { seg } from './ui';

export type RosterView = 'ljudje' | 'ekipe';

/**
 * Prostovoljci carries two lists: the roster, and the external teams that cover
 * posts without being ours to brief (SPEC §1.1J).
 *
 * The switch sits at the top of the sidebar rather than in a page header,
 * because the sidebar list is exactly what changes between the two — and it is
 * built from `seg()` rather than Mantine's SegmentedControl so it matches the
 * quick-filter chips immediately below it.
 */
export function ViewSwitch({
  view,
  setView,
  people,
  teams,
}: {
  view: RosterView;
  setView: (v: RosterView) => void;
  people: number;
  teams: number;
}) {
  const item = (key: RosterView, label: string, count: number) => (
    <button
      key={key}
      type="button"
      onClick={() => setView(key)}
      aria-pressed={view === key}
      style={{
        flex: 1,
        cursor: 'pointer',
        padding: '6px 8px',
        borderRadius: 6,
        fontSize: rem(12.5),
        fontWeight: view === key ? 600 : 500,
        fontFamily: 'inherit',
        ...seg(view === key),
      }}
    >
      {label} {count}
    </button>
  );

  return (
    <div
      style={{
        padding: '10px 12px 9px',
        borderBottom: '1px solid oklch(0.94 0.005 95)',
        display: 'flex',
        gap: 5,
      }}
    >
      {item('ljudje', 'Prostovoljci', people)}
      {item('ekipe', 'Zunanje ekipe', teams)}
    </div>
  );
}
